import React from "react"
import AsyncSelectBase from "react-select/async"
import CreatableSelectBase, { CreatableProps } from "react-select/creatable"
import SelectBase, { components, OptionTypeBase } from "react-select"
import "./Select.scss"
import styles from "./Select.module.scss"
import Spinner from "../Spinner/Spinner"
import { OptionType } from "../AsyncSearchableInput/AsyncSearchableInput"
import { AsyncProps } from "react-select/src/Async"
import { Props as SelectProps } from "react-select/src/Select"
import cn from "classnames"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretDown, faTimes } from "@fortawesome/pro-light-svg-icons"
import { testId } from "../../utility/tests/testId/common"

export interface SelectCustomProps {
    invalid?: boolean
}

export type SelectOption = { label: string; value: string; extra?: { [key: string]: string | number | boolean } }

const LoadingIndicator = () => <Spinner className="custom-select__spinner" size={15} />
const ClearIndicator = (props: React.ComponentPropsWithRef<typeof components.ClearIndicator>) => {
    return (
        <div className={styles.indicator}>
            <FontAwesomeIcon
                icon={faTimes}
                className={styles.indicator__icon}
                onClick={props.clearValue}
                data-testid={testId.indicatorIconClearValue}
            />
        </div>
    )
}
const DropdownIndicator = () => (
    <div className={styles.indicator}>
        <FontAwesomeIcon icon={faCaretDown} className={styles.indicator__icon} />
    </div>
)

export const AsyncSelect: React.FC<SelectProps<OptionType, false> & AsyncProps<OptionType> & SelectCustomProps> =
    props => (
        <AsyncSelectBase
            {...props}
            menuShouldScrollIntoView={false}
            classNamePrefix="custom-select"
            components={{
                LoadingIndicator,
                ClearIndicator,
                DropdownIndicator
            }}
            className={cn(props.className, props.invalid && "custom-select_invalid")}
        />
    )

export const Select: React.FC<SelectProps & SelectCustomProps> = props => (
    <SelectBase
        {...props}
        menuShouldScrollIntoView={false}
        classNamePrefix="custom-select"
        className={cn(props.className, props.invalid && "custom-select_invalid")}
        components={{ DropdownIndicator, ClearIndicator, ...props.components }}
    />
)

export interface CreatableSelectProps extends SelectProps {
    hideDropdownIndicator?: boolean
    isValidNewOption?: CreatableProps<OptionTypeBase, boolean>["isValidNewOption"]
}

export const CreatableSelect: React.FC<CreatableSelectProps> = props => (
    <CreatableSelectBase
        {...props}
        classNamePrefix="custom-select"
        className={cn(props.className, props.invalid && "custom-select_invalid")}
        components={{ DropdownIndicator: props.hideDropdownIndicator ? null : DropdownIndicator, ClearIndicator }}
    />
)
